import React, { JSX } from "react";
import { Box, Typography } from "@mui/material";

function PrintRow({
  label,
  children,
  shouldAvoidPageBreak = false,
  nextLineChildren = false,
  labelWidth = 120,
  hideColon = false
}: {
  label: JSX.Element | string;
  children: JSX.Element | JSX.Element[] | string;
  nextLineChildren?: boolean;
  shouldAvoidPageBreak?: boolean;
  labelWidth?: number | string;
  hideColon?: boolean;
}): JSX.Element {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: nextLineChildren ? "column" : "row",
        alignItems: "baseline",
        gap: nextLineChildren ? 0.5 : 1,
        justifyContent: nextLineChildren ? "center" : "flex-start",
        pageBreakInside: shouldAvoidPageBreak ? "avoid" : "auto",
        pageBreakAfter: "auto"
      }}
    >
      <Typography sx={{ fontWeight: 600, width: labelWidth }}>
        {label}
        {!hideColon && ":"}
      </Typography>

      {nextLineChildren ? (
        <Typography variant="subtitle1" sx={{ width: "100%" }}>
          {children}
        </Typography>
      ) : (
        <Typography variant="subtitle1" component="div" sx={{ width: "100%" }}>
          {children}
        </Typography>
      )}
    </Box>
  );
}

export default PrintRow;
